import themeNavigation from './components/navigation.js';
import {
  logosURL,
  applySubthemeClass,
  storage,
  isPage,
  validateSubtheme,
} from './utils/helpers.js';
import { foundationTheme } from './foundation/local.js';
import { fiberTheme } from './fiber/local.js';

export function themeController(themeData) {
  if (isPage('homepage')) {
    // Subthemes cleanup on homepage
    storage.setItem('subTheme', false);
    storage.setItem('subThemeName', '');
  } else {
    // Applies subtheme class to body
    applySubthemeClass(themeData);
    // Executes code for the subtheme
    foundationTheme();
    fiberTheme();
  }

  if (validateSubtheme(themeData)) {
    $('.header .main-theme-header').remove();
    $('.footer .main-theme-footer').remove();
  }

  // Header logo URL
  logosURL(themeData);

  // Custom Navigation
  themeNavigation(themeData);

  setTimeout(() => {
    $('body').addClass('loaded');
  }, 500);
}
